import Vue from 'vue'
import Vuex from 'vuex'
import auth from './store/modules/auth'
import user from './store/modules/user'
import provider from './store/modules/provider'
import security from './store/modules/security'
import parkingReservations from './store/modules/parking_reservations'
import WebSocketService from './services/websocketService'

let wsService = null;

const debug = process.env.NODE_ENV !== 'production';
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        snackbar_activate: false,
        snackbar_message: '',
        snackbar_color: 'success',
        language: 'es',
        caseta_vigilante: 0,
        qrDevices: localStorage.getItem('qr_devices') !== null ? JSON.parse(localStorage.getItem('qr_devices')) : [],
        camDevices: localStorage.getItem('cam_devices') !== null ? JSON.parse(localStorage.getItem('cam_devices')) : [],
        websocket_connected: false,
        websocket_modal_open: false,
        websocket_event: null,
    },
    mutations: {
        snackbar_change_message(state, a_message) {
            state.snackbar_message = a_message
        },
        snackbar_activate_false(state) {
            state.snackbar_activate = false
        },
        snackbar_activate_true(state) {
            state.snackbar_activate = true
        },
        snackbar_change_color(state, a_color) {
            state.snackbar_color = a_color
        },
        change_language(state, a_language) {
            state.language = a_language
        },
        change_caseta_vigilante(state, an_id_caseta) {
            state.caseta_vigilante = an_id_caseta
        },
        setQRDevices(state, devices) {
            state.qrDevices = devices
        },
        setCamDevices(state, devices) {
            state.camDevices = devices
        },
        SET_WEBSOCKET_CONNECTED(state, connected) {
            state.websocket_connected = connected
        },
        SHOW_WEBSOCKET_MODAL(state, show) {
            state.websocket_modal_open = show
        },
        SET_WEBSOCKET_EVENT(state, event) {
            state.websocket_event = event
        }
    },
    getters: {
        isWebsocketConnected: state => state.websocket_connected,
        isWebsocketModalOpen: state => state.websocket_modal_open,
        getWebsocketEvent: state => state.websocket_event,
    },
    actions: {
        CONNECT_WS({ getters, commit, state }) {
            const profile = getters.getProfile
            
            // Intentar obtener nombre de empresa desde múltiples campos
            let companyName = null
            if (profile && profile.name_company) {
                companyName = profile.name_company
            } else if (profile && profile.empresa && profile.empresa.name) {
                companyName = profile.empresa.name
            } else if (profile && profile.empresa_name) {
                companyName = profile.empresa_name
            } else if (profile && profile.company_name) {
                companyName = profile.company_name
            }
            
            if (!companyName) {
                console.warn('[CONNECT_WS] No se encontró company name en el perfil')
                return
            }
            
            // Extraer solo letras y convertir a minúsculas
            companyName = companyName.replace(/[^a-zA-Z]/g, '').toLowerCase()
            
            if (!companyName) {
                console.warn('[CONNECT_WS] Nombre de empresa vacío después del procesamiento')
                return
            }
            
            console.log('[CONNECT_WS] Conectando con empresa:', companyName)
            
            // Evitar sesiones duplicadas: desconectar la anterior si existe
            if (wsService) {
                wsService.disconnect()
                wsService = null
            }
            
            // Crear un store-like object con los métodos necesarios para WebSocketService
            const storeProxy = {
                commit: commit,
                getters: { getProfile: () => profile }
            }
            wsService = new WebSocketService(storeProxy)
            wsService.connect(companyName)
        },
        DISCONNECT_WS() {
            if (wsService) {
                wsService.disconnect()
                wsService = null
            }
        }
    },
    modules: {
        user,
        auth,
        provider,
        security,
        parking_reservations: parkingReservations
    },
    strict: debug,
})
